import { render, staticRenderFns } from "./EditBrandDialog.vue?vue&type=template&id=19378ed5&"
import script from "./EditBrandDialog.vue?vue&type=script&lang=js&"
export * from "./EditBrandDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports